import { useDispatch, useSelector } from 'react-redux';
import { loadDBDataTypes } from 'js/actions';

export default function useDbDataTypes() {
  const dispatch = useDispatch();
  const allTypes = useSelector((state: any) => state.dbDataTypes);
  function loadDbDataTypes(connection) {
    dispatch(loadDBDataTypes(connection));
  }

  function getDbDataTypes(connection) {
    return allTypes[connection];
  }

  return {
    loadDbDataTypes,
    getDbDataTypes,
  };
}
